module.exports = __webpack_public_path__ + "static/img/kong_yu_xie_tong_pop_bg.c6885f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/kong_yu_xie_tong_pop_bg.png
// module id = Y9Hn
// module chunks = 2